module.exports = __webpack_public_path__ + "img/huilu.dd83b85d.png";